import { useInfiniteQuery } from 'react-query';
import { toast } from 'react-toastify';
import { PAGE_SIZE } from 'utils/constants';
import { DjangoListResponse, InvitedUserEntity } from 'v2/models';
import restFactory from 'v2/utils/restFactory';
import { infiniteUserInvitesKeys } from './query-keys';

async function fetchUserInvites({ pageParam = 1 }) {
  const response = await restFactory.get<DjangoListResponse<InvitedUserEntity>>(
    '/dj/api/v1/invite_user/',
    {
      page: pageParam,
      size: PAGE_SIZE,
    }
  );

  return {
    ...response,
    prev: pageParam,
    next: response.next ? pageParam + 1 : undefined,
  };
}

export function useInfiniteUserInvites() {
  return useInfiniteQuery(infiniteUserInvitesKeys.all, fetchUserInvites, {
    refetchOnWindowFocus: false,
    onError: () => {
      toast.error('Error loading invited users.');
    },
    getNextPageParam: (lastPage) => lastPage.next,
  });
}
